module.exports = __webpack_public_path__ + "static/media/abstract.4a522af1.svg";